// Keep catalog search focused on product names/grades. Shopify's general search
// can include loosely related products from other indexed fields.
(() => {
  const elements = new Map();
  const elementList = document.querySelector('[data-element-list]')?.dataset.elementList || '';
  for (const entry of elementList.trim().split(';')) {
    const [symbol, name] = entry.split(',');
    if (!symbol || !name) continue;
    const element = { symbol, name };
    elements.set(symbol.toLowerCase(), element);
    elements.set(name.toLowerCase(), element);
  }
  // Common English name; the element's formal name remains Chromium.
  if (elements.has('cr')) elements.set('chrome', elements.get('cr'));

  const elementIndex = document.querySelector('[data-element-index-url]')?.dataset.elementIndexUrl;
  const elementUrl = (symbol) => {
    if (!elementIndex) return null;
    const url = new URL(elementIndex, window.location.href);
    url.searchParams.set('filter.p.m.custom.constituent_elements', symbol);
    url.searchParams.set('element', symbol);
    url.hash = 'products';
    return url.toString();
  };

  const titleQuery = (input) => input.trim().split(/\s+/).map((word) => {
    const safe = word.replace(/[\\"]/g, '').trim();
    const material = elements.get(safe.toLowerCase())?.name || safe;
    return material ? `title:"${material}"` : '';
  }).filter(Boolean).join(' ');

  document.querySelectorAll('form[data-product-search]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const field = form.elements.namedItem('q');
      if (!field || !field.value.trim()) return;
      event.preventDefault();
      const element = elements.get(field.value.trim().toLowerCase());
      const browseUrl = element && elementUrl(element.symbol);
      if (browseUrl) {
        window.location.assign(browseUrl);
        return;
      }
      const url = new URL(form.action, window.location.href);
      url.searchParams.set('q', titleQuery(field.value));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'none');
      window.location.assign(url.toString());
    });
  });

  const searchRoute = document.querySelector('form[data-product-search]')?.action;
  if (!searchRoute || window.location.pathname !== new URL(searchRoute).pathname) return;
  const url = new URL(window.location.href);
  const query = url.searchParams.get('q')?.trim();
  const type = url.searchParams.get('type');
  if (!query || (type && type !== 'product') || query.includes('title:') || /\b(?:tag|vendor|product_type):/i.test(query)) return;
  const element = elements.get(query.toLowerCase());
  const browseUrl = element && elementUrl(element.symbol);
  if (browseUrl) {
    window.location.replace(browseUrl);
    return;
  }
  url.searchParams.set('q', titleQuery(query));
  url.searchParams.set('type', 'product');
  url.searchParams.set('options[prefix]', 'none');
  window.location.replace(url.toString());
})();
